var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a", { class: _vm.styles.navItem, attrs: { href: _vm.href } }, [
    _c("i", { staticClass: "material-icons", class: _vm.styles.navIcon }, [
      _vm._v(_vm._s(_vm.module.icon)),
    ]),
    _c("span", { class: _vm.styles.navLabel }, [
      _vm._v(_vm._s(_vm.module.title)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }